import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom';
import AuditDashboard from '../modules/audit/auditDashboard/AuditDashboard';
import Vendor from '../modules/audit/vendor/Vendor';
import CreateAudit from '../modules/audit/audit/createAudit/CreateAudit';
import CreateReport from '../modules/global/Settings/DeveloperSettings/CreateReport/CreateReport';
import AccessConfiguration from '../modules/global/Settings/DeveloperSettings/AccessConfiguration/AccessConfiguration';
import AssignPermission from '../modules/global/Settings/permissions/AssignPermission';
import CreateRole from '../modules/global/Settings/permissions/CreateRole';
import AssignClient from '../modules/global/Settings/permissions/AssignClient';
import CreateUsers from '../modules/global/Settings/permissions/CreateUsers';
import Permissions from '../modules/global/Settings/permissions/Permissions';
import ClientForm from '../modules/global/Settings/ClientMasterAndUnitMaster/clientform';
import Clientunit from '../modules/global/Settings/ClientMasterAndUnitMaster/units/UnitClients';
import AuditDetails from '../modules/audit/audit/auditDetails/auditDetails';
import TemplateMapping from '../modules/audit/TemplateMapping/TemplateMapping';
import VendorAudit from '../modules/audit/VendorViews/VendorAudit/VendorAudit';
import VendorAuditUpdate from '../modules/audit/VendorViews/VendorAuditUpdate/VendorAuditUpdate';
import AuditDetailsUpdate from '../modules/audit/audit/auditDetails/AuditDetailsUpdate';
import ChangePassword from '../modules/global/auth/ChangePassword/ChangePassword';
import AuditReport from '../modules/audit/auditReport/AuditReport';
import TrackAudit from '../modules/audit/trackAudit/TrackAudit';
// import AuditReportView from '../modules/audit/auditReport/auditReportView/AuditReportView';
export function Audit_routes({ showSnackbar, setLoading, permissionMap = {} }) {
  const use_company_code = JSON.parse(sessionStorage.getItem('user'));
  const currentUserBaseRole = use_company_code?.base_role;
  return (
    <>
      <Route path="/" element={<Navigate to="/dashboard" />} />
      <Route path="/reset_password" element={<ChangePassword  showSnackbar={showSnackbar} setLoading={setLoading} />}/>
      <Route path="/dashboard" element={<AuditDashboard />} />
      {permissionMap["Configuration"]?.["Org Details"] && ( 
        <>
        <Route path="/configuration/org-details" element={<ClientForm showSnackbar={showSnackbar} setLoading={setLoading} />} />
        <Route path="/configuration/unit-master/:id" element={<Clientunit showSnackbar={showSnackbar} setLoading={setLoading} />} />
        </>
      )}
      {permissionMap?.["Configuration"]?.["User & Role Management"]?.includes("Create Users") && (
        <Route path="/configuration/user-role-management/users" element={<CreateUsers showSnackbar={showSnackbar} setLoading={setLoading} />} />
      )}
      {permissionMap?.["Configuration"]?.["User & Role Management"]?.includes("Assign Client") && (
        <Route path="/configuration/user-role-management/users-client" element={<AssignClient showSnackbar={showSnackbar} setLoading={setLoading} />} />
      )}
      {permissionMap?.["Configuration"]?.["User & Role Management"]?.includes("Create Role") && (
        <Route path="/configuration/user-role-management/role" element={<CreateRole showSnackbar={showSnackbar} setLoading={setLoading} />} />
      )}
      {permissionMap?.["Configuration"]?.["User & Role Management"]?.includes("Assign Permissions")  && (
        <Route path="/configuration/user-role-management/role-permission" element={<AssignPermission showSnackbar={showSnackbar} setLoading={setLoading} />} />
      )}
      {permissionMap?.["Configuration"]?.["Template Mapping"] && (
        <Route path="/configuration/template-mapping" element={<TemplateMapping showSnackbar={showSnackbar} setLoading={setLoading} />} />
      )}
      {permissionMap?.["Audit"]?.["Vendor"] && (
        <Route path="/audit-vendor" element={<Vendor setLoading={setLoading} showSnackbar={showSnackbar}/>} />
      )}
      {permissionMap?.["Audit"]?.["Audit Details"] && (
      <>
        <Route path='/audit-details' element={<AuditDetails setLoading={setLoading} showSnackbar = {showSnackbar}/>} />   
        <Route path="/audit-details/view/:id" element={<AuditDetailsUpdate Action={"View"} showSnackbar={showSnackbar} setLoading={setLoading} />} />
        <Route path="/audit-details/view-update/:id" element={<AuditDetailsUpdate Action={"Work"} showSnackbar={showSnackbar} setLoading={setLoading} />} />
        <Route path="/audit-details/view-completed/:id" element={<AuditDetailsUpdate Action={"Complated"} showSnackbar={showSnackbar} setLoading={setLoading} />} />
        <Route path="/audit-details/view-expired/:id" element={<AuditDetailsUpdate Action={"Expired"} showSnackbar={showSnackbar} setLoading={setLoading} />} />
      </>
      )}
      {permissionMap?.["Audit"]?.["Create Audit"] && (
      <Route path='/create-audit' element={<CreateAudit setLoading={setLoading} showSnackbar = {showSnackbar}/>} /> 
      )}

      
       

      {/* vendor view */}
      {currentUserBaseRole === "vendor" &&
        <>
          <Route path='/vendor/Audit' element={<VendorAudit showSnackbar={showSnackbar} setLoading={setLoading} />}/>
          <Route path={`/vendor/audit/:id`} element={<VendorAuditUpdate showSnackbar={showSnackbar} setLoading={setLoading} />}/>
        </>
      }

      <Route path="/audit-report" element={<AuditReport showSnackbar={showSnackbar} setLoading={setLoading}/>} />
      <Route path="/track-audit" element={<TrackAudit showSnackbar={showSnackbar} setLoading={setLoading}/>} />
      {/* <Route path={`/audit-report-view`} element={<AuditReportView showSnackbar={showSnackbar} setLoading={setLoading}/>} /> */}
      
      <Route path="/configuration/developer-settings/access-configuration" element={<AccessConfiguration showSnackbar={showSnackbar} setLoading={setLoading} />} />
      <Route path="/configuration/developer-settings/create-report" element={<CreateReport showSnackbar={showSnackbar} setLoading={setLoading} />} />
    </>
  )
}

